/**
 * الإشعارات والتنبيهات is the one home of the system-wide notification switches (owner, 2026-10-29). Its own tabs
 * (sources, log, global settings) plus three pages that moved in as tabs, each still behind its own page id, so its
 * permission and صلاحيات المستخدمين decide who sees it; its old address opens the tab here (router.tsx).
 *
 * Per-client message switches stay on the client page (ClientNotifySection).
 */
export const NOTIFY_HUB_PATH = '/settings/notifications-hub'
export const NOTIFY_PARAM = 'tab'

export const NOTIFY_OWN_TABS = ['sources', 'log', 'settings'] as const
export interface NotifyEmbeddedTab { key: string; page: string; ar: string; en: string }
export const NOTIFY_EMBEDDED: NotifyEmbeddedTab[] = [
  { key: 'inapp', page: 'notifications.settings', ar: 'إشعارات النظام', en: 'In-app preferences' },
  { key: 'alerts', page: 'controlRoom.alertRules', ar: 'قواعد التنبيهات', en: 'Alert rules' },
  { key: 'hr', page: 'hr.notify', ar: 'تنبيهات الموارد البشرية', en: 'HR alerts' },
]
export const NOTIFY_MOVED_IDS = new Set(NOTIFY_EMBEDDED.map((t) => t.page))

/** The home's address for a page that moved in as a tab, keeping that page's own query. */
export function notifyHubUrl(pageId: string, search = ''): string {
  const tab = NOTIFY_EMBEDDED.find((t) => t.page === pageId)
  const q = new URLSearchParams(search)
  q.delete(NOTIFY_PARAM)
  const rest = q.toString()
  return `${NOTIFY_HUB_PATH}${tab ? `?${NOTIFY_PARAM}=${tab.key}` : ''}${rest ? `${tab ? '&' : '?'}${rest}` : ''}`
}
